module.exports = __webpack_public_path__ + "img/chord-down-shadow.080afe3c.png";